export const CLIENT_REQUEST_ID = 'x-client-request-id';
export const RID_SIGNATURE = 'x-rid-signature';
export const RAMBLER_RPC_ID = 'x-rambler-rpc-id';
export const getHeaders = ({ requestId, signature, ...headers }) => ({
    'Content-Type': 'application/json',
    ...headers,
    ...(requestId && { [CLIENT_REQUEST_ID]: requestId }),
    ...(signature && { [RID_SIGNATURE]: signature })
});
